import { FactionsById, FactionsByName } from './types/faction.js';
var FactionIdToName = function FactionIdToName(id) {
  return FactionsById[id];
};
var FactionNameToId = function FactionNameToId(name) {
  return FactionsByName[name.toLowerCase()];
};
var OtherFaction = function OtherFaction(activeFactions, occupier) {
  return activeFactions.find(function (x) {
    return x !== void 0 && x !== occupier && x < 500010;
  });
};
var BuildAdvantage = function BuildAdvantage(faction, advantage) {
  var _ref = advantage.find(function (_ref2) {
      var factionID = _ref2.factionID;
      return factionID === faction;
    }) || {},
    _ref$terrainAmount = _ref.terrainAmount,
    terrainAmount = _ref$terrainAmount === void 0 ? 0 : _ref$terrainAmount,
    _ref$dynamicAmount = _ref.dynamicAmount,
    dynamicAmount = _ref$dynamicAmount === void 0 ? 0 : _ref$dynamicAmount,
    _ref$totalAmount = _ref.totalAmount,
    totalAmount = _ref$totalAmount === void 0 ? 0 : _ref$totalAmount;
  return {
    terrainAmount: terrainAmount,
    dynamicAmount: dynamicAmount,
    totalAmount: totalAmount,
    factionID: faction
  };
};
var ResolveAdvantage = function ResolveAdvantage(attacker, defender) {
  if (attacker.totalAmount === defender.totalAmount) return {
    amount: 0
  };
  return {
    faction: attacker.totalAmount > defender.totalAmount ? attacker.factionID : defender.factionID,
    amount: Math.abs(attacker.totalAmount - defender.totalAmount)
  };
};
var roundContested = function roundContested(x) {
  return Math.round(x * 100 * 100) / 100;
};
var roundAdvantage = function roundAdvantage(x) {
  return Math.round(x * 100) / 100;
};
export { BuildAdvantage, FactionIdToName, FactionNameToId, OtherFaction, ResolveAdvantage, roundAdvantage, roundContested };